<div class="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
  <div class="p-5 space-y-4">
    <h1
      class="mb-2 text-2xl font-bold leading-tight tracking-tight text-gray-900 text-center">
      Pay for appointment
    </h1>
    <div
      class="flex items-center text-base text-primary-800 bg-primary-100 py-3 px-5 rounded-lg flex gap-2 leading-[120%]">
      <icaredx-display-avatar
        [profileImageUrl]="''"
        [givenName]="providerNameSplited.givenName"
        [familyName]="providerNameSplited.familyName">
      </icaredx-display-avatar>
      <div>
        To schedule an appointment with
        <span class="font-semibold">{{ provider()!.providerName }}</span
        >, please place your order.
      </div>
    </div>
    <div class="border border-gray-200 p-6 leading-[150%]">
      <h3 class="font-semibold text-xl text-gray-900">Order amount</h3>

      @if (hasBreakdown()) {
        <div class="mt-4">
          <div class="flex justify-between">
            <div class="font-normal text-base text-gray-500">Subtotal</div>
            <div class="font-medium text-base text-gray-900">
              {{ subtotalDollars() | currency: 'USD' }}
            </div>
          </div>
          @if (hasDiscount()) {
            <div class="mt-2 flex justify-between">
              <div class="font-normal text-base text-gray-500">Discount</div>
              <div class="font-medium text-base text-teal-600">
                -{{ totalDiscountDollars() | currency: 'USD' }}
              </div>
            </div>
          }
          @if ((data.taxAmountCents ?? 0) > 0) {
            <div class="mt-2 flex justify-between">
              <div class="font-normal text-base text-gray-500">
                {{ taxLabel() }}
              </div>
              <div class="font-medium text-base text-gray-900">
                {{ taxAmountDollars() | currency: 'USD' }}
              </div>
            </div>
          }
        </div>

        <div class="mt-4 pt-2 border-t border-gray-200">
          <div class="flex justify-between font-bold text-base text-gray-900">
            <div>Total</div>
            <div>{{ totalDollars() | currency: 'USD' }}</div>
          </div>
        </div>
      } @else {
        <div class="mt-4">
          <div class="flex justify-between">
            <div class="font-normal text-base text-gray-500">
              Original price
            </div>
            <div class="font-medium text-base text-gray-900">
              {{ data.servicesCost | currency: 'USD' }}
            </div>
          </div>
          @if (hasDiscount()) {
            <div class="mt-2 flex justify-between">
              <div class="font-normal text-base text-gray-500">Discount</div>
              <div class="font-medium text-base text-teal-600">
                -{{ totalDiscountDollars() | currency: 'USD' }}
              </div>
            </div>
          }
        </div>

        <div class="mt-4 pt-2 border-t border-gray-200">
          <div class="flex justify-between font-bold text-base text-gray-900">
            <div>Total</div>
            <div>
              {{ discountedServicesCost() | currency: 'USD' }}
            </div>
          </div>
        </div>
      }

      <button
        (click)="submit()"
        class="mt-4 w-full text-white bg-primary-700 enabled:hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:bg-gray-100 disabled:text-gray-500 cursor-pointer">
        @if (submitting()) {
          <icaredx-spinner size="small"></icaredx-spinner>
        } @else {
          Place your order
        }
      </button>
      @if (data.bookingIntentId) {
        <button
          type="button"
          (click)="cancelBooking()"
          class="mt-2 w-full text-red-700 bg-white border border-red-300 hover:bg-red-50 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center cursor-pointer">
          Cancel booking
        </button>
      }
      <div class="mt-4 font-medium text-sm text-gray-500">
        By placing your order, you agree to iCareDx’s
        <button
          class="inline text-primary-700 cursor-pointer underline hover:text-primary-800"
          (click)="openDisclaimer('privacyPolicy')">
          privacy note
        </button>
        and
        <button
          class="inline text-primary-700 cursor-pointer underline hover:text-primary-800"
          (click)="openDisclaimer('termsOfService')">
          terms of use</button
        >.
      </div>
    </div>
  </div>
</div>
